<template>
<div id="notFound">
  <h1>It's classic 404 Not Found :)</h1>
</div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style>
#notFound{
  font-family: 'Encode Sans Condensed', sans-serif;
  background-image: radial-gradient(rgba(127, 193, 204, 0.867), rgb(105, 211, 95));
}
</style>
